import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import LandingPage from './pages/EnhancedLandingPage';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Vehicles from './pages/Vehicles';
import VehicleDetail from './pages/VehicleDetail';
import AddVehicle from './pages/AddVehicle';
import Reminders from './pages/Reminders';
import Expenses from './pages/Expenses';
import Maintenance from './pages/Maintenance';
import MileageFuel from './pages/MileageFuel';
import Accidents from './pages/Accidents';
import AccidentDetail from './pages/AccidentDetail';
import CreateAccident from './pages/CreateAccident';
import Profile from './pages/Profile';
import ScanDocument from './pages/ScanDocument';
import Pricing from './pages/Pricing';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AdminSettings from './pages/AdminSettings';
import Analytics from './pages/Analytics';
import UserManagement from './pages/UserManagement';
import RecordIncident from './pages/RecordIncident';
import Incidents from './pages/Incidents';
import IncidentDetail from './pages/IncidentDetail';
import AuthCallback from './components/AuthCallback';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import UpgradeModalManager from './components/UpgradeModalManager';
import InstallPrompt from './components/InstallPrompt';
import './App.css';

function AppRouter() {
  const location = useLocation();
  
  // Check for OAuth callback session_id in URL hash (synchronously during render)
  // This prevents race conditions by processing OAuth BEFORE ProtectedRoute checks auth
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      
      <Route path="/app" element={
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      }>
        <Route index element={<Dashboard />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="vehicles" element={<Vehicles />} />
        <Route path="vehicles/add" element={<AddVehicle />} />
        <Route path="vehicles/:id" element={<VehicleDetail />} />
        <Route path="reminders" element={<Reminders />} />
        <Route path="expenses" element={<Expenses />} />
        <Route path="mileage" element={<MileageFuel />} />
        <Route path="maintenance" element={<Maintenance />} />
        <Route path="accidents" element={<Accidents />} />
        <Route path="accidents/new" element={<CreateAccident />} />
        <Route path="accidents/:id" element={<AccidentDetail />} />
        <Route path="scan" element={<ScanDocument />} />
        <Route path="profile" element={<Profile />} />
        <Route path="admin" element={<AdminSettings />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="users" element={<UserManagement />} />
        <Route path="incidents" element={<Incidents />} />
        <Route path="incidents/record" element={<RecordIncident />} />
        <Route path="incidents/:id" element={<IncidentDetail />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" />
        <UpgradeModalManager />
        <InstallPrompt />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
